import { Fragment } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { useIntl } from 'react-intl'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import NavBarListItem from 'components/NavKit/NavBarListItem'
import NavBarListItemDivider from 'components/NavKit/NavBarListItemDivider'
import useMerchandiseLabels from 'hooks/Merchandise/useMerchandiseLabels'
import IconPlaceholder from './components/IconPlaceholder'
import { useDrawerTracking } from 'analytics/snowplow/events/megaMenuEvents'

const ItemsSection = styled.div`
  display: flex;
  flex-direction: column;
  padding-inline: ${rem(8)};
`

const StyledNavBarListItem = styled(NavBarListItem)`
  padding-block: ${rem(12)};
  gap: ${rem(8)};
`

function MerchandiseTravelEssentialsDrawer() {
  const intl = useIntl()
  const { travelEssentialsItems } = useMerchandiseLabels()
  const { trackItemClick } = useDrawerTracking('travel_essential')

  return (
    <ModalBase mode="drawer">
      <ModalHeader
        title={intl.formatMessage({
          id: '94l6piMCNnSGCR-pXkP4',
          defaultMessage: 'Travel Essentials',
          description: 'Heading title for merchandise travel essentials drawer',
        })}
      />
      <ModalBody>
        <ModalContent flush>
          <ItemsSection>
            {travelEssentialsItems.map((item, index) => (
              <Fragment key={item.id}>
                <StyledNavBarListItem
                  title={item.name}
                  to={item.url}
                  onClick={() => trackItemClick(item, index)}
                  endIcon={<IconPlaceholder size={24} />}
                />
                <NavBarListItemDivider />
              </Fragment>
            ))}
          </ItemsSection>
        </ModalContent>
      </ModalBody>
    </ModalBase>
  )
}

export default MerchandiseTravelEssentialsDrawer
